var Mustache = require("mustache")

export default class IcmaDoc {
    constructor() {
        //eslint-disable-next-line
        this.json = `{"pageSize":"LETTER","pageMargins":[45,60,45,60],"content":[{"alignment": "left","bold": true,"color": "red","text": "{{{instructions}}}","margin": [0, -15, 0, 0]},{"text":"Contractor Release and Waiver of Liability and Workers' Compensation Coverage","alignment":"center","bold":true,"fontSize":12,"margin":[0,0,0,24]},{"text":["This Release and Waiver of Liability and Worker's Compensation Coverage (the ",{"text":"¨Release¨","bold":true},") is executed on the {{{dayOrdinal}}} day of {{{monthName}}}, {{{year}}} by {{{userName}}} (",{"text":"¨Contractor¨","bold":true},")."]},{"text":"Waiver of Workers' Compensation Coverage","style":"subtitle"},"Contractor affirms and agrees:",{"ol":[{"text":["That he/she is an independent contractor, with no employees, no casual laborers, and no subcontractors performing work for Elite Logistics, Inc. (",{"text":"¨Elite¨","bold":true},");"],"style":"listitem"},{"text":"Contractor is not an employee of Elite for workers' compensation purposes, and therefore is not entitled to workers' compensation benefts under Elite's policy coverage; and","style":"listitem"},{"text":"Contractor waives any and all rights to file any claims against Elite in the event an accident should occur while contractor is performing services for Elite.","style":"listitem"}],"margin":[20,10,0,0]},{"text":"Release and Waiver of Liability","style":"subtitle"},{"text":"Contractor releases Elite and each of its successors, assigns, directors, officers, employees, agents and Subcontractors.","style":"para"},{"text":"Now therefore, for good and valuable consideration, the receipt and sufficiency of which are hereby acknowledged, the parties hereby agree as follows:","style":"para"},{"text":"The Contractor desires to provide services to Elite and engage in activites related to such service.","style":"para"},{"text":"Contractor understands that he/she is responsible for his/her own insurance coverage in the event of personal injury or illness as a result of services provided to Elite.","style":"para"},{"ol":[{"text":[{"text":"Waiver and Release: ","style":"listhead"},"Contractor, for his/her heirs, executors, administrators and assigns, hereby release, waive, discharge and hold harmless, Elite and its successors, assigns, directors, officers, employees and agents from any and all liability, claim and demands of whatever kind of nature, either in law or in equity, which arise or may hereafter arise from the services I provide to Elite. Contractor understands and acknowledges that this Release discharges Elite from any liability or claim that Contractor may have against Elite with respect to bodily injury, personal injury, illness, death, property damage, or any other claim that may result from the services Contractor provides to Elite or occurring while Contractor is providing services."],"style":"listitem"},{"text":[{"text":"Insurance: ","style":"listhead"},"Further, Contractor understands that Elite does not assume any responsibility for or obligation to provide Contractor with financial or other assistance, including but not limited to medical, health, workers' compensation, or disability benefits or insurance. Contractor expressly waives any such claims for compensation or liability on the part of Elite beyond what may be offered freely by Elite in the event of injury or medical expenses incurred by Contractor."],"style":"listitem"},{"text":[{"text":"Medical Treatment: ","style":"listhead"},"Contractor hereby releases and forever discharges Elite from any claim whatsoever which arises or may hereafter arise on account of any first-aid treatment or other medical services rendered in connection with an emergency during Contractor's tenure as a Contractor with Elite."],"style":"listitem"},{"text":[{"text":"Assumption of Risk: ","style":"listhead"},"Contractor understands that the services Contractor provides to Elite may include activities that may be hazardous. As a Contractor, I hereby expressly assume risk of injury or harm from these activities and release Elite from all liability."],"style":"listitem"},{"text":[{"text":"Other: ","style":"listhead"},"As a Contractor, I expressly agree that this Release is intended to be as broad and inclusive as permitted by the laws of the State of Colorado and that this Release shall be governed by and interpreted in accordance with the laws of the State of Colorado. Contractor agrees that in the event that any clause or provision of this Release is deemed invalid, the enforceability of the remaining provisions of this Release shall not be affected."],"style":"listitem"}],"margin":[0,8,0,10]},{"text":"By signing below, Contractor expresses his/her understanding and intent to enter into this Contractor Release and Waiver of Liability and Workers' Compensation Coverage willingly and voluntarily.","margin":[0,0,0,30]},{"columns":[{"width":120,"text":"Dated:","bold":true,"margin":[0,0,0,25]},{"width":120,"text":"{{{date}}}"}]},{"columns":[{"width":120,"text":"Contractor Name:","bold":true,"margin":[0,0,0,25]},{"width":120,"text":"{{{userName}}}"}]},{"columns":[{"width":120,"text":"DBA:","bold":true,"margin":[0,0,0,25]},{"width":120,"text":"{{{companyName}}}"}]},{"text":"Signature:","bold":true},{"image":"{{{signature}}}","fit":[90,250],"margin":[130,-24,0,0]},{"canvas":[{"type":"line","x1":120,"y1":0,"x2":280,"y2":0,"lineWidth":1}]}],"defaultStyle":{"fontSize":10,"bold":false},"styles":{"subtitle":{"fontSize":11,"bold":true,"alignment":"left","margin":[0,16,0,8]},"listitem":{"margin":[0,0,0,12]},"listhead":{"bold":true,"italics":true},"para":{"margin":[0,0,0,8]},"label":{"bold":true}}}`

        /*
        this.formatted = `
{
  "pageSize": "LETTER",
  "pageMargins": [
    45,
    60,
    45,
    60
  ],
  "content": [
    {
      "alignment": "left",
      "bold": true,
      "color": "red",
      "text": "{{{instructions}}}",
      "margin": [0, -15, 0, 0]
    },
    {
      "text": "Contractor Release and Waiver of Liability and Workers' Compensation Coverage",
      "alignment": "center",
      "bold": true,
      "fontSize": 12,
      "margin": [
        0,
        0,
        0,
        24
      ]
    },
    {
      "text": [
        "This Release and Waiver of Liability and Worker's Compensation Coverage (the ",
        {
          "text": "¨Release¨",
          "bold": true
        },
        ") is executed on the {{{dayOrdinal}}} day of {{{monthName}}}, {{{year}}} by {{{userName}}} (",
        {
          "text": "¨Contractor¨",
          "bold": true
        },
        ")."
      ]
    },
    {
      "text": "Waiver of Workers' Compensation Coverage",
      "style": "subtitle"
    },
    "Contractor affirms and agrees:",
    {
      "ol": [
        {
          "text": [
            "That he/she is an independent contractor, with no employees, no casual laborers, and no subcontractors performing work for Elite Logistics, Inc. (",
            {
              "text": "¨Elite¨",
              "bold": true
            },
            ");"
          ],
          "style": "listitem"
        },
        {
          "text": "Contractor is not an employee of Elite for workers' compensation purposes, and therefore is not entitled to workers' compensation benefts under Elite's policy coverage; and",
          "style": "listitem"
        },
        {
          "text": "Contractor waives any and all rights to file any claims against Elite in the event an accident should occur while contractor is performing services for Elite.",
          "style": "listitem"
        }
      ],
      "margin": [
        20,
        10,
        0,
        0
      ]
    },
    {
      "text": "Release and Waiver of Liability",
      "style": "subtitle"
    },
    {
      "text": "Contractor releases Elite and each of its successors, assigns, directors, officers, employees, agents and Subcontractors.",
      "style": "para"
    },
    {
      "text": "Now therefore, for good and valuable consideration, the receipt and sufficiency of which are hereby acknowledged, the parties hereby agree as follows:",
      "style": "para"
    },
    {
      "text": "The Contractor desires to provide services to Elite and engage in activites related to such service.",
      "style": "para"
    },
    {
      "text": "Contractor understands that he/she is responsible for his/her own insurance coverage in the event of personal injury or illness as a result of services provided to Elite.",
      "style": "para"
    },
    {
      "ol": [
        {
          "text": [
            {
              "text": "Waiver and Release: ",
              "style": "listhead"
            },
            "Contractor, for his/her heirs, executors, administrators and assigns, hereby release, waive, discharge and hold harmless, Elite and its successors, assigns, directors, officers, employees and agents from any and all liability, claim and demands of whatever kind of nature, either in law or in equity, which arise or may hereafter arise from the services I provide to Elite. Contractor understands and acknowledges that this Release discharges Elite from any liability or claim that Contractor may have against Elite with respect to bodily injury, personal injury, illness, death, property damage, or any other claim that may result from the services Contractor provides to Elite or occurring while Contractor is providing services."
          ],
          "style": "listitem"
        },
        {
          "text": [
            {
              "text": "Insurance: ",
              "style": "listhead"
            },
            "Further, Contractor understands that Elite does not assume any responsibility for or obligation to provide Contractor with financial or other assistance, including but not limited to medical, health, workers' compensation, or disability benefits or insurance. Contractor expressly waives any such claims for compensation or liability on the part of Elite beyond what may be offered freely by Elite in the event of injury or medical expenses incurred by Contractor."
          ],
          "style": "listitem"
        },
        {
          "text": [
            {
              "text": "Medical Treatment: ",
              "style": "listhead"
            },
            "Contractor hereby releases and forever discharges Elite from any claim whatsoever which arises or may hereafter arise on account of any first-aid treatment or other medical services rendered in connection with an emergency during Contractor's tenure as a Contractor with Elite."
          ],
          "style": "listitem"
        },
        {
          "text": [
            {
              "text": "Assumption of Risk: ",
              "style": "listhead"
            },
            "Contractor understands that the services Contractor provides to Elite may include activities that may be hazardous. As a Contractor, I hereby expressly assume risk of injury or harm from these activities and release Elite from all liability."
          ],
          "style": "listitem"
        },
        {
          "text": [
            {
              "text": "Other: ",
              "style": "listhead"
            },
            "As a Contractor, I expressly agree that this Release is intended to be as broad and inclusive as permitted by the laws of the State of Colorado and that this Release shall be governed by and interpreted in accordance with the laws of the State of Colorado. Contractor agrees that in the event that any clause or provision of this Release is deemed invalid, the enforceability of the remaining provisions of this Release shall not be affected."
          ],
          "style": "listitem"
        }
      ],
      "margin": [
        0,
        8,
        0,
        10
      ]
    },
    {
      "text": "By signing below, Contractor expresses his/her understanding and intent to enter into this Contractor Release and Waiver of Liability and Workers' Compensation Coverage willingly and voluntarily.",
      "margin": [
        0,
        0,
        0,
        30
      ]
    },
    {
      "columns": [
        {
          "width": 120,
          "text": "Dated:",
          "bold": true,
          "margin": [
            0,
            0,
            0,
            25
          ]
        },
        {
          "width": 120,
          "text": "{{{date}}}"
        }
      ]
    },
    {
      "columns": [
        {
          "width": 120,
          "text": "Contractor Name:",
          "bold": true,
          "margin": [
            0,
            0,
            0,
            25
          ]
        },
        {
          "width": 120,
          "text": "{{{userName}}}"
        }
      ]
    },
    {
      "columns": [
        {
          "width": 120,
          "text": "DBA:",
          "bold": true,
          "margin": [
            0,
            0,
            0,
            25
          ]
        },
        {
          "width": 120,
          "text": "{{{companyName}}}"
        }
      ]
    },
    {
      "text": "Signature:",
      "bold": true
    },
    {
      "image": "{{{signature}}}",
      "fit": [
        90,
        250
      ],
      "margin": [
        130,
        -24,
        0,
        0
      ]
    },
    {
      "canvas": [
        {
          "type": "line",
          "x1": 120,
          "y1": 0,
          "x2": 280,
          "y2": 0,
          "lineWidth": 1
        }
      ]
    }
  ],
  "defaultStyle": {
    "fontSize": 10,
    "bold": false
  },
  "styles": {
    "subtitle": {
      "fontSize": 11,
      "bold": true,
      "alignment": "left",
      "margin": [
        0,
        16,
        0,
        8
      ]
    },
    "listitem": {
      "margin": [
        0,
        0,
        0,
        12
      ]
    },
    "listhead": {
      "bold": true,
      "italics": true
    },
    "para": {
      "margin": [
        0,
        0,
        0,
        8
      ]
    },
    "label": {
      "bold": true
    }
  }
}
          `
          */
    }

    getDocStructure(args) {
        let dd = Mustache.render(this.json, args)
        let obj = JSON.parse(dd)

        return obj
    }
}
